 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import {commitMutation} from 'react-relay'



import isTempId from '../utils/relay/isTempId'
import handleRemoveTasks from './handlers/handleRemoveTasks'

graphql`
  fragment DeleteTaskMutation_task on DeleteTaskPayload {
    task {
      id
    }
  }
`

const mutation = graphql`
  mutation DeleteTaskMutation($taskId: ID!) {
    deleteTask(taskId: $taskId) {
      error {
        message
      }
      ...DeleteTaskMutation_task @relay(mask: false)
    }
  }
`

export const deleteTaskTaskUpdater = (
  payload,
  {store}
) => {
  const taskId = _optionalChain([payload, 'access', _ => _.getLinkedRecord, 'call', _2 => _2('task'), 'optionalAccess', _3 => _3.getValue, 'call', _4 => _4('id')])
  handleRemoveTasks(taskId, store)
}

const DeleteTaskMutation = (atmosphere, variables) => {
  const {taskId} = variables
  if (isTempId(taskId)) return undefined
  return commitMutation(atmosphere, {
    mutation,
    variables,
    updater: (store) => {
      const payload = store.getRootField('deleteTask')
      if (!payload) return
      deleteTaskTaskUpdater(payload, {atmosphere, store})
    },
    optimisticUpdater: (store) => {
      handleRemoveTasks(taskId, store)
    }
  })
}

export default DeleteTaskMutation
